import React from 'react';

import * as ResourceApi from 'api/resources';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import {createButtonSectionFactory, createButtonSectionFactoryWithAdditionalArgs} from "hoc/CreateButtonSection";
import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';
import {hasAllUserTagPermissions} from 'utils/DBUtils';
import {
    PollAnswerButtonBkgdColorToolTip,
    PollAnswerButtonBkgdToolTip,
    PollAnswerButtonTextColorToolTip,
    PollAnswerButtonTextToolTip,
    PollAnswerButtonTxtColorToolTip,
    PollAnswerToolTip,
    PollEditButtonColorsToolTip,
    PollHeadlineToolTip,
    PollIntroCopyToolTip,
    PollQuestionImageToolTip,
    PollQuestionResultGraphColorToolTip,
    PollQuestionResultImageToolTip,
    PollQuestionResultTextToolTip,
    PollQuestionToolTip,
    PollResultGraphFailToolTip,
    PollResultGraphSuccessToolTip,
    PollAnswerButtonBgHoverToolTip,
    NextQuestionButtonBgToolTip,
    NextQuestionButtonTextToolTip,
    NextQuestionButtonBgHoverToolTip,
    DropdownButtonBgToolTip,
    DropdownButtonTextToolTip,
    DropdownButtonBgHoverToolTip
} from 'components/break/tooltips/poll-tool-tips';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import {isNewLayout} from 'utils/break-utils';
import ResourceForm from 'components/forms/ResourceForm';

export default {
    name: "poll",
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,

    fields: [
        {
            type: 'contenteditable',
            name: 'headline',
            required: true,
            // Headline is only allowed if there is more than one Poll step
            showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            linkedField: (formProxy) => ["title"],
            props: {
                labelKey: 'editbreak.steps.poll.headline',
                helpContent: <PollHeadlineToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.headline'}/></IntlProvider>
            }
        },
        {
            type: 'image',
            name: 'headerImageId',
            required: false,
            idFor: 'headerImage',

            props: {
                labelKey: 'editbreak.steps.poll.header_image',
                imageType: 'stepHeaderImage'
            }
        },
        {
            type: 'contenteditable',
            name: 'introCopy',
            required: false,
            props: {
              labelKey: 'editbreak.steps.poll.intro_copy',
              maxLength: 500,
              placeholderKey: 'editbreak.steps.poll.intro_copy.placeholder',
              helpContent: <PollIntroCopyToolTip/>,
              helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.intro'}/></IntlProvider>,
              validationRules: [
                  {
                      type: 'MarkupTextLimit',
                      params: {
                          limit: 500
                      }
                  }
              ]
            }
        },
        {
            type: 'text',
            name: 'commentQuestion',
            showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored'),
            props: {
                labelKey: 'editbreak.steps.related_breaks.commentQuestion',
                helpContent: <FBCommentQuestionToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'answerBgColor',
            required: true,

            props: {
                labelKey: 'editbreak.steps.poll.answerButtonBorder',
                helpContent: <PollAnswerButtonBkgdToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.answerButtonBorder'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'answerTextColor',
            required: true,

            props: {
                labelKey: 'editbreak.steps.poll.answerButtonText',
                helpContent: <PollAnswerButtonTextToolTip/>,
                helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.answerButtonText'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'answerBgHoverColor',
            required: true,

            props: {
                labelKey: 'editbreak.steps.poll.answerButtonBorderHover',
                helpContent: <PollAnswerButtonBgHoverToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.answerButtonBorderHover'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'nextQuestionButtonBgColor',
            required: true,

            props: {
                labelKey: 'editbreak.steps.poll.nextQuestionButtonBackground',
                helpContent: <NextQuestionButtonBgToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.nextQuestionButtonBackground'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'nextQuestionButtonTextColor',
            required: true,

            props: {
                labelKey: 'editbreak.steps.poll.nextQuestionButtonText',
                helpContent: <NextQuestionButtonTextToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.nextQuestionButtonText'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'nextQuestionButtonBgHoverColor',
            required: true,

            props: {
                labelKey: 'editbreak.steps.poll.nextQuestionButtonBackgroundHover',
                helpContent: <NextQuestionButtonBgHoverToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.nextQuestionButtonBackgroundHover'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'dropdownButtonBgColor',
            required: true,

            props: {
                labelKey: 'editbreak.steps.poll.dropdownButtonBackground',
                helpContent: <DropdownButtonBgToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.dropdownButtonBackground'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'dropdownButtonTextColor',
            required: true,

            props: {
                labelKey: 'editbreak.steps.poll.dropdownButtonText',
                helpContent: <DropdownButtonTextToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.dropdownButtonText'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'dropdownButtonBgHoverColor',
            required: true,

            props: {
                labelKey: 'editbreak.steps.poll.dropdownButtonBackgroundHover',
                helpContent: <DropdownButtonBgHoverToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.dropdownButtonBackgroundHover'}/></IntlProvider>
            }
        },
        {
            name: 'questions',
            subSection: true,
            resource: true,
            collection: true,
            sectionWrapper: IndexedSubSectionWrapper,
            deletable: true,
            canDelete: (formProxy) => {
              var poll = formProxy.parentCurrentResource;
              return poll.questions && poll.questions.length > 1;
            },

            sortable: true,
            sortableName: "questionsOrder",
            toggleSortLabelKey: 'editbreak.steps.poll.question.reorder_toggle',
            resourceType: ResourceApi.Types.PollQuestion,

            props: {
                headerKey: 'editbreak.steps.poll.question.header',
                getCustomSectionHeader: (question, sectionIndex) => {
                  return  question.type === 'TEXT'
                          && question.question
                          && question.question.trim() !== "" ? "Question " + (sectionIndex + 1) + ": " + question.question : null;
                },
                headerIcon: 'question'
            },

            footerContent: createButtonSectionFactory(ResourceApi.Types.PollQuestion),

            fields: [
                {
                    type: 'radio',
                    name: 'type',
                    required: true,

                    props: {
                        labelKey: 'editbreak.steps.poll.question.type',
                        options: [
                            {
                                value: "TEXT",
                                textKey: 'editbreak.steps.poll.question.type.text'
                            },
                            {
                                value: "VIDEO",
                                textKey: 'editbreak.steps.poll.question.type.video'
                            }
                        ]
                    }
                },
                {
                    key: "PollQuestionTypeSwitch",
                    subSection: true,
                    viewSwitch: (formProxy) => {
                        return formProxy.currentResource.type
                    },

                    viewCases: {
                        TEXT: [
                            {
                                type: 'contenteditable',
                                name: 'question',
                                required: true,

                                props: {
                                    labelKey: 'editbreak.steps.poll.question.question',
                                    helpContent: <PollQuestionToolTip/>,
                                    helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.question'}/></IntlProvider>
                                }
                            },
                            {
                                type: 'image',
                                name: 'image',
                                required: false,
                                idFor: 'imageAsset',
                                showField: (proxy) =>  (!proxy.currentResource.useDefaultImage && !isNewLayout(proxy.currentBaseResource)),
                                props: {
                                    labelKey: 'editbreak.steps.poll.question.image',
                                    imageType: 'custom',
                                    helpContent: <PollQuestionImageToolTip/>,
                                    helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.questionImage'}/></IntlProvider>
                                }
                            },
                            {
                                type: 'image',
                                name: 'image',
                                required: false,
                                idFor: 'imageAsset',
                                showField: (proxy) =>  (!proxy.currentResource.useDefaultImage && isNewLayout(proxy.currentBaseResource)),
                                props: {
                                    labelKey: 'editbreak.steps.poll.question.image',
                                    imageType: 'custom',
                                    helpContent: <PollQuestionImageToolTip/>,
                                    helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.questionImage'}/></IntlProvider>
                                }
                            },
                            {
                              conditionalSection: true,
                              name: "useDefaultImage",
                              required: true,
                              props: {
                                  labelKey: 'editbreak.steps.poll.question.use_default_image'
                              },

                              fields: [
                                {
                                  type: 'dropdown',
                                  name: 'defaultImageId',
                                  required: true,
                                  props: {
                                    labelKey: 'editbreak.steps.poll.question.default_image',
                                    options: [
                                      {
                                        text: '',
                                        value: ''
                                      },
                                      {
                                        text: 'Purple Rainbow Gradient',
                                        value: '9812ff0a-22af-427d-9748-3fdf7913affc',
                                        imageId: '9812ff0a-22af-427d-9748-3fdf7913affc'
                                      },
                                      {
                                        text: 'Purple Shooting Star',
                                        value: '304ad25b-6e1d-48d6-807f-17e695730bd2',
                                        imageId: '304ad25b-6e1d-48d6-807f-17e695730bd2'
                                      },
                                      {
                                        text: 'Purple Tie Dye',
                                        value: 'ffc1637f-5073-4620-ab23-db03182712dd',
                                        imageId: 'ffc1637f-5073-4620-ab23-db03182712dd'
                                      },
                                      {
                                        text: 'Purple Sound Waves',
                                        value: '79d4611a-d20f-4d5c-a798-f5df31ea2e7e',
                                        imageId: '79d4611a-d20f-4d5c-a798-f5df31ea2e7e'
                                      },
                                      {
                                        text: 'Purple Milky Way',
                                        value: '21b1ff99-a40a-4a78-82aa-130d5d8f2b4b',
                                        imageId: '21b1ff99-a40a-4a78-82aa-130d5d8f2b4b'
                                      },
                                      {
                                        text: 'Black Gradient',
                                        value: '9f35e19b-b5ee-4d3e-bdc2-c8ce269d886c',
                                        imageId: '9f35e19b-b5ee-4d3e-bdc2-c8ce269d886c'
                                      },
                                      {
                                        text: 'Plum Tapestry',
                                        value: '425913d3-d34a-48d5-be99-294d250e6805',
                                        imageId: '425913d3-d34a-48d5-be99-294d250e6805'
                                      },
                                      {
                                        text: 'Purple Tapestry',
                                        value: '85568cb5-94e0-485a-8e4b-c4b86d54bc88',
                                        imageId: '85568cb5-94e0-485a-8e4b-c4b86d54bc88'
                                      },
                                      {
                                        text: 'Purple Wood Panes',
                                        value: '8afdf75d-c003-4f1b-a019-698422445412',
                                        imageId: '8afdf75d-c003-4f1b-a019-698422445412'
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            {
                              type: 'image',
                              name: 'socialShareImageId',
                              required: false,
                              idFor: 'socialShareImage',
                              showField: (proxy) =>  (proxy.currentBaseResource.sponsoredType === 'sponsored'),
                              props: {
                                labelKey: 'editbreak.steps.poll.question.social_share_image',
                                imageType: 'pollSocialShare'
                              }

                            }
                        ],
                        VIDEO: [
                            {
                                type: 'textarea',
                                name: 'videoEmbed',
                                required: true,

                                props: {
                                    labelKey: 'editbreak.steps.poll.question.video_embed'
                                }
                            },
                        ]
                    }
                },
                {
                    name: 'answers',
                    subSection: true,
                    resource: true,
                    collection: true,
                    sectionWrapper: IndexedSubSectionWrapper,
                    deletable: true,
                    canDelete: (formProxy) => {
                      var parentQuestion = formProxy.parentCurrentResource;
                      return parentQuestion.answers && parentQuestion.answers.length > 2;
                    },

                    sortable: true,
                    sortableName: "answersOrder",
                    toggleSortLabelKey: 'editbreak.steps.poll.answer.reorder_toggle',
                    resourceType: ResourceApi.Types.PollAnswer,

                    props: {
                        headerKey: 'editbreak.steps.poll.question.answer.header',
                        getCustomSectionHeader: (answer, sectionIndex) => {
                          return  answer.type === 'TEXT'
                                  && answer.answer
                                  && answer.answer.trim() !== "" ? "Answer " + (sectionIndex+1) + ": " + answer.answer : null;
                        },
                        headerIcon: 'answer'
                    },

                    footerContent: createButtonSectionFactory(ResourceApi.Types.PollAnswer),

                    fields: [
                        {
                            type: 'radio',
                            name: 'type',
                            required: true,

                            props: {
                                labelKey: 'editbreak.steps.poll.answer.type',
                                options: [
                                    {
                                        value: "TEXT",
                                        textKey: 'editbreak.steps.poll.answer.type.text'
                                    },
                                    {
                                        value: "IMAGE",
                                        textKey: 'editbreak.steps.poll.answer.type.image'
                                    }
                                ]
                            }
                        },
                        {
                            type: 'contenteditable',
                            name: 'answer',
                            required: (proxy) => ( proxy.currentResource.type === 'TEXT' ),

                            props: {
                                labelKey: 'editbreak.steps.poll.question.answer',
                                helpContent: <PollAnswerToolTip/>,
                                helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.answer'}/></IntlProvider>
                            }
                        },
                        {
                          type: 'image',
                          name: 'image',
                          required: true,
                          idFor: 'imageAsset',
                          showField: (proxy) =>  (proxy.currentResource.type === 'IMAGE'),
                          props: {
                            labelKey: 'editbreak.steps.poll.answer.image',
                            //   imageType: 'pollAnswer'
                              imageType: 'custom'
                          }
                        },
                        {
                        name: 'dropdownButton',
                        subSection: true,
                        resource: true,
                        collection: false,
                        sectionWrapper: IndexedSubSectionWrapper,
                        
                        showSection: (proxy) =>  ((proxy.parentCurrentResource.type === 'IMAGE') || (proxy.currentResource != null)),
                        deletable: true,
                        canCreate: true,
                        resourceType: ResourceApi.Types.DropdownButton,
                        props: {
                            headerKey: 'CTA Button',
                        },

                        // footerContent: createButtonSectionFactory(ResourceApi.Types.DropdownButton),
                
                        fields: [
                            {
                                type: 'hardcodedText',
                                key: "links-helper",
                                props: {
                                text: 'If you include a single link, the UI will show a button. Incude multiple links and the UI will show a dropdown button.',
                                }
                            },
                            {
                                type: "contenteditable",
                                name: "label",
                                required: false,
                                props: {
                                labelKey: "Button Copy",
                                    disabled: false,
                                },
                                showField: (proxy) => {
                                    return true;
                                //   let links = proxy.currentResource.links.filter((item) => { 
                                //     return item.deleted === false
                                //   })
            
                                //   return (links.length > 1)
                                },
                            },
                            {
                                name: "links",
                                subSection: true,
                                resource: true,
                                collection: true,
                                sectionWrapper: IndexedSubSectionWrapper,
                                deletable: true,
                                canDelete: (formProxy) => {
                                // logic like this would force at least one item
                                //   var parentReview = formProxy.parentCurrentResource;
                                //   return parentReview.products && parentReview.products.length > 1;
                                    return true
                                },
                                sortable: true,
                                sortableName: "linksOrder",
                                resourceType: ResourceApi.Types.DropdownButtonLink,
                                toggleSortLabelKey: "editbreak.steps.grocery.resultLink.reorder_toggle",
                                props: {
                                //headerKey: 'editbreak.steps.grocery.resultLink.section_header',
                                getCustomSectionHeader: (item, sectionIndex) => {
                                    return item.label ? item.label : `Link - ${ (sectionIndex + 1) }`
                                    // return product.dropdownTitle
                                    // && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
                                }
                                },
                            
                    
                                footerContent: createButtonSectionFactory(ResourceApi.Types.DropdownButtonLink),
                    
                                fields: [
                                {
                                    type: "contenteditable",
                                    name: "label",
                                    required: false,
                                    props: {
                                    labelKey: "Label",
                                    },
                                },
                                {
                                    type: "text",
                                    name: "url",
                                    required: false,
                                    props: {
                                    labelKey: "Url",
                                    },
                                },
                    
                                ],
                            },
                            {
                                conditionalSection: true,
                                name: "editDropdownButtonColors",
                                required: false,
                                props: {
                                    labelKey: 'editbreak.steps.poll.dropdown_button.edit_colors'
                                },

                                fields: [
                                    {
                                        type: "color",
                                        name: "bgColor",
                                        props: {
                                            labelKey: "editbreak.steps.poll.dropdown_button.bgColor"
                                        }
                                    },
                                    {
                                        type: "color",
                                        name: "textColor",
                                        props: {
                                            labelKey: "editbreak.steps.poll.dropdown_button.textColor"
                                        }
                                    },
                                    {
                                        type: "color",
                                        name: "bgHoverColor",
                                        props: {
                                            labelKey: "editbreak.steps.poll.dropdown_button.bgHoverColor"
                                        }
                                    }
                                ]
                            },
                        ],
                    },
                    {
                        type: 'hardcodedText',
                        showField: (proxy) => {
                            // console.log(`hardcodedText`, )
                            // return ((proxy.currentBaseResource.sponsoredType === 'sponsored') )
                            return ((proxy.currentBaseResource.sponsoredType === 'sponsored') && (proxy.currentResource.dropdownButton == null))
                        },
                        props: {
                            helperText: 'This button is a bit janky. After clicking the button, close and re-open the parent answer section and the new fields will appear. '
                        }
                    },


                    ]
                }, // end answers array
                {
                  type: 'contenteditable',
                  name: 'textAnswered',
                  required: false,
                  props: {
                    labelKey: 'editbreak.steps.poll.question.result_text',
                    helpContent: <PollQuestionResultTextToolTip/>,
                    helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.questionResultText'}/></IntlProvider>
                  }
                },
                {
                  type: 'image',
                  name: 'textAnsweredImageId',
                  required: false,
                  showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
                  props: {
                    labelKey: 'editbreak.steps.poll.question.result_image',
                    helpContent: <PollQuestionResultImageToolTip/>,
                      imageType: "pollAnswerImageOptions",
                    helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.questionResultImage'}/></IntlProvider>
                  }
                },
                {
                    type: 'image',
                    name: 'textAnsweredImageId',
                    required: false,
                    showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                    props: {
                      labelKey: 'editbreak.steps.poll.question.result_image',
                      helpContent: <PollQuestionResultImageToolTip/>,
                        imageType: "pollAnswerImageOptions2020",
                      helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.questionResultImage'}/></IntlProvider>
                    }
                  },
                  {
                    conditionalSection: true,
                    name: "editResultGraphColors",
                    required: true,

                    props: {
                        labelKey: 'editbreak.steps.poll.question.edit_result_graph_colors',
                        helpContent: <PollQuestionResultGraphColorToolTip/>,
                        helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.questionGraphQuestion'}/></IntlProvider>
                    },

                    fields: [
                        {
                            type: "color",
                            name: "userSelectionResultBarColor",
                            required: true,
                            props: {
                                labelKey: 'editbreak.steps.poll.question.result.user_selection_result_bar_color',
                                helpContent: <PollResultGraphSuccessToolTip/>,
                                helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.poll.question.result.user_selection_result_bar_color'}/></IntlProvider>
                            }
                        },
                        {
                            type: "color",
                            name: "otherSelectionsResultBarColor",
                            required: true,
                            props: {
                                labelKey: 'editbreak.steps.poll.question.result.other_selections_result_bar_color',
                                helpContent: <PollResultGraphFailToolTip/>,
                                helpHeader:<IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.poll.question.result.other_selections_result_bar_color'}/></IntlProvider>
                            }
                        }
                    ]
                },
                           
            ]
        }, // end questions array

        // {
        //     type: 'resourceDropdown',
        //     name: 'test',
        //     required: true,
        //     itemTransformer: (item) => {
        //             return {
        //                 text: item.headline,
        //                 value: item.id
        //             }
        //         },
        //     props: {
        //         labelKey: 'Test',
        //         resource: 'Poll',
        //         itemTransformer: (item) => {
        //             return {
        //                 text: item.headline,
        //                 value: item.id
        //             }
        //         }
        //     }
        // },

        {
            type: 'hardcodedText',
            showField: (proxy) => {
                return (proxy.currentBaseResource.sponsoredType === 'sponsored')
            }, 
            props: {
                heading: 'Product Panel',
            }
        },
        {
            name: 'productPanel',
            subSection: true,
            resource: true,
            collection: false,
            sectionWrapper: IndexedSubSectionWrapper,
            // sectionWrapper defaults to a BasicForm
            // sectionWrapper: ResourceForm,
            deletable: true,
            sortable: false,
            resourceType: ResourceApi.Types.ProductPanel,
            canCreate: (proxy) => {
                console.log(`canCreate productPanel`, proxy.currentResource) // 
                return (proxy.currentResource == null)
            },
            showSection: (proxy) => {
                console.log(`showSection`, proxy.currentBaseResource, (proxy.currentBaseResource.sponsoredType === 'sponsored'))
                // console.log(proxy.currentBaseResource) // break
                // console.log(proxy.currentResource) // should be a productPanel - is null if a product panel hasn't been created yet
                // console.log(proxy.parentCurrentResource)    // shows Poll
                return ((proxy.currentBaseResource.sponsoredType === 'sponsored') || (proxy.currentResource != null))
            },
            
            props: {
                headerKey: 'Product Panel',
            },

            footerContent: createButtonSectionFactory(ResourceApi.Types.ProductPanel),
          
            fields: [
                {
                    type: "contenteditable",
                    name: "headline",
                    required: false,
                    showField: (proxy) => {
                        return (proxy.currentResource != null)
                    }, 
                    props: {
                        labelKey: "Headline",
                    },
                },

                {
                    name: 'products',
                    subSection: true,
                    resource: true,
                    collection: true,
                    sectionWrapper: IndexedSubSectionWrapper,
                    deletable: true,

                    sortable: true,
                    sortableName: "productsOrder",
                    toggleSortLabelKey: 'editbreak.steps.poll.answer.reorder_toggle',
                    resourceType: ResourceApi.Types.ProductPanelProduct,
                    canCreate: (proxy) => {
                        console.log(`canCreate products`, proxy.currentResource)
                        // return (proxy.currentResource != null)
                        return true
                    },

                    props: {
                        headerKey: 'editbreak.steps.poll.question.answer.header',
                        // getCustomSectionHeader: (item, sectionIndex) => {
                        //     return item && item.label || "Product"
                        // },

                        // innerHeader: true,
                        // getInnerHeader: () => "Product Panel"
                        // getInnerHeader: (a, b, c) => {
                        //     console.log("????", a, b, c)
                        //     return "Product Panel Item"
                        // },
                        getCustomSectionHeader: (item, sectionIndex) => {
                            return item.label ? item.label : `Product - ${ (sectionIndex + 1) }`
                        }
                    //     // return product.dropdownTitle
                    //     // && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
                    // }


                    },

                    footerContent: createButtonSectionFactory(ResourceApi.Types.ProductPanelProduct),

                    fields: [
                        {
                            type: 'text',
                            name: 'label',
                            required: false,
                            props: {
                                labelKey: 'Internal label',
                            }
                        },
                        {
                            type: 'image',
                            name: 'imageId',
                            required: false,
                            idFor: 'image',

                            props: {
                                labelKey: 'Image',
                                imageType: 'custom'
                            }
                        },
                        // {
                        //     type: 'contenteditable',
                        //     name: 'introCopy',
                        //     required: false,
                        //     props: {
                        //         labelKey: 'editbreak.steps.poll.intro_copy',
                        //         placeholderKey: 'editbreak.steps.poll.intro_copy.placeholder',
                        //     }
                        // },
                        {
                        name: 'dropdownButton',
                        subSection: true,
                        resource: true,
                        collection: false,
                        // IndexedSubSectionWrapper is for arrays
                        sectionWrapper: IndexedSubSectionWrapper,
                        //   showSection: (proxy) => (proxy.parentCurrentResource.buttonType === 'MENU'),
                        deletable: true,
                            canCreate: true,
                            resourceType: ResourceApi.Types.DropdownButton,
                        props: {
                            headerKey: 'CTA Button',
                        },

                        // footerContent: createButtonSectionFactory(ResourceApi.Types.DropdownButton),
                
                        fields: [
                            // {
                            //     type: 'hardcodedText',
                            //     key: "links-helper",
                            //     props: {
                            //     text: 'If you include a single link, the UI will show a button. Incude multiple links and the UI will show a dropdown button.',
                            //     }
                            // },
                            {
                                type: "contenteditable",
                                name: "label",
                                required: false,
                                props: {
                                labelKey: "Button Copy",
                                    disabled: false,
                                },
                                showField: (proxy) => {
                                    return true;
                                //   let links = proxy.currentResource.links.filter((item) => { 
                                //     return item.deleted === false
                                //   })
            
                                //   return (links.length > 1)
                                },
                            },
                            {
                                name: "links",
                                subSection: true,
                                resource: true,
                                collection: true,
                                sectionWrapper: IndexedSubSectionWrapper,
                                deletable: true,
                                canDelete: (formProxy) => {
                                // logic like this would force at least one item
                                //   var parentReview = formProxy.parentCurrentResource;
                                //   return parentReview.products && parentReview.products.length > 1;
                                    return true
                                },
                                sortable: true,
                                sortableName: "linksOrder",
                                resourceType: ResourceApi.Types.DropdownButtonLink,
                                toggleSortLabelKey: "editbreak.steps.grocery.resultLink.reorder_toggle",
                                props: {
                                //headerKey: 'editbreak.steps.grocery.resultLink.section_header',
                                getCustomSectionHeader: (item, sectionIndex) => {
                                    return item.label ? item.label : `Link - ${ (sectionIndex + 1) }`
                                    // return product.dropdownTitle
                                    // && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
                                }
                                },
                            
                    
                                footerContent: createButtonSectionFactory(ResourceApi.Types.DropdownButtonLink),
                    
                                fields: [
                                {
                                    type: "contenteditable",
                                    name: "label",
                                    required: false,
                                    props: {
                                    labelKey: "Label",
                                    },
                                },
                                {
                                    type: "text",
                                    name: "url",
                                    required: false,
                                    props: {
                                    labelKey: "Url",
                                    },
                                },
                    
                                ],
                            },
                            {
                                conditionalSection: true,
                                name: "editDropdownButtonColors",
                                required: false,
                                props: {
                                    labelKey: 'editbreak.steps.poll.dropdown_button.edit_colors'
                                },

                                fields: [
                                    {
                                        type: "color",
                                        name: "bgColor",
                                        props: {
                                            labelKey: "editbreak.steps.poll.dropdown_button.bgColor"
                                        }
                                    },
                                    {
                                        type: "color",
                                        name: "textColor",
                                        props: {
                                            labelKey: "editbreak.steps.poll.dropdown_button.textColor"
                                        }
                                    },
                                    {
                                        type: "color",
                                        name: "bgHoverColor",
                                        props: {
                                            labelKey: "editbreak.steps.poll.dropdown_button.bgHoverColor"
                                        }
                                    }
                                ]
                            },
                        ],
                    },
                    ]
                }




            ]
        },
        {
            type: 'hardcodedText',
            showField: (proxy) => {
                console.log(`hardcodedText`, )
                // return ((proxy.currentBaseResource.sponsoredType === 'sponsored') )
                return ((proxy.currentBaseResource.sponsoredType === 'sponsored') && (proxy.currentResource.productPanel == null))
            }, 
            props: {
                helperText: 'Product Panel in Beaker is a bit janky. After clicking the button to add a product panel, close and re-open the parent poll section. '
            }
        },


        {
            type: 'currentId',
            label: 'Poll ID',
        },
    ],
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/poll.js